import { createStore } from '../store-creator';
import type { SearchItemsStoreData as StoreData } from './types';
// TODO remove query-params-analysis-store when QueryContext is tested ok
const useSearchItemsStore = createStore<StoreData>(
  'search-excluded',
  (set) => ({
    updatedSearchItems: [],
    setUpdatedSearchItems: (updatedSearchItems) =>
      set((state) => ({
        updatedSearchItems:
          typeof updatedSearchItems === 'function'
            ? updatedSearchItems(state.updatedSearchItems)
            : updatedSearchItems,
      })),
  })
);

export default useSearchItemsStore;
